export const triggerTypes = {
  button: 'Button',
  banner: 'Banner',
  dropdownMenu: {
    trigger: 'DropDown Menu',
    option: 'DropDown Option',
  },
}
